// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/icn-checkbox-checked.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/icn-checkbox-checked-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/icn-checkbox-checked-read-only.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.checkbox-module__checkbox___WmLHf {
  width: 100%;
  display: flex;
}
.checkbox-module__checkbox--reversed___LecXB {
  flex-direction: row-reverse;
  justify-content: flex-end;
}
.checkbox-module__checkbox__checkmark___dboH6 {
  border-radius: 5px;
  border: 1px solid var(--neutral45, #b3b9be);
  background-image: none;
  height: 22px;
  width: 22px;
  flex-shrink: 0;
}
.checkbox-module__checkbox__checkmark___dboH6 > input {
  height: 100%;
  width: 100%;
  opacity: 0;
  margin: 0;
}
.checkbox-module__checkbox__checkmark___dboH6:focus-within {
  outline: var(--focus, #2681e1) solid 2px;
  outline-offset: 3px;
}
.checkbox-module__checkbox__checkmark--checked___kU20r {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
}
.checkbox-module__checkbox__checkmark--checked-dark___PA4vf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 100% 100%;
}
.checkbox-module__checkbox__checkmark--checked-read-only___eqsK6 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 100% 100%;
  border: none;
  width: 24px;
  height: 24px;
}
.checkbox-module__checkbox__checkmark--sftp-steps___qKRNI, .checkbox-module__checkbox__checkmark--invite-modal-comp___BjjP6, .checkbox-module__checkbox__checkmark--format___clFr3, .checkbox-module__checkbox__checkmark--preview___cHWHW, .checkbox-module__checkbox__checkmark--health-coaching___ccn_P {
  border: 1px solid var(--primary600, #4b286d);
}
.checkbox-module__checkbox__title___CxVRF {
  vertical-align: middle;
  font-size: 0.875rem;
  height: 20px;
  color: var(--neutral100, #2c2e30);
  transition: 0.3s ease-out color;
}
.checkbox-module__checkbox__title___CxVRF a {
  color: var(--primary600, #4b286d);
  font-weight: 600;
}
.checkbox-module__checkbox__title___CxVRF a:focus {
  outline: var(--focus, #2681e1) solid 2px;
  outline-offset: 3px;
}
.checkbox-module__checkbox__title--sftp-steps___cKLYT {
  padding-top: 1px;
}
.checkbox-module__checkbox__title--invite-modal-comp___P1lTO {
  font-size: 1rem;
  color: var(--neutral100, #2c2e30);
}
.checkbox-module__checkbox__title--consents___SbqZk {
  height: auto;
}
.checkbox-module__checkbox__title--preview___LmN_T, .checkbox-module__checkbox__title--appointments-form___mVFlu {
  font-size: 1rem;
  font-weight: 600;
}
.checkbox-module__checkbox__subtitle___xjWqz {
  display: inline-block;
  vertical-align: middle;
  max-width: calc(100% - 32px);
  font-size: 0.875rem;
  color: var(--neutral75, #424547);
}
.checkbox-module__checkbox__label___ALUoq {
  padding-left: 12px;
  display: inline-flex;
  align-items: center;
}
.checkbox-module__checkbox__label--appointments-form___q7ryI {
  width: 100%;
}
.checkbox-module__checkbox__label--sftp-steps___paVws {
  padding-left: 8px;
}
.checkbox-module__checkbox__label--invite-modal-comp___XPGSn {
  display: block;
}
.checkbox-module__checkbox__label--checked___s2lyD .checkbox-module__checkbox__title___CxVRF {
  color: var(--primary600, #4b286d);
}
.checkbox-module__checkbox__label--checked___s2lyD .checkbox-module__checkbox__title--consents___SbqZk, .checkbox-module__checkbox__label--checked___s2lyD .checkbox-module__checkbox__title--sftp-steps___cKLYT, .checkbox-module__checkbox__label--checked___s2lyD .checkbox-module__checkbox__title--invite-modal-comp___P1lTO, .checkbox-module__checkbox__label--checked___s2lyD .checkbox-module__checkbox__title--format___c6t25, .checkbox-module__checkbox__label--checked___s2lyD .checkbox-module__checkbox__title--preview___LmN_T, .checkbox-module__checkbox__label--checked___s2lyD .checkbox-module__checkbox__title--appointments-form___mVFlu {
  color: var(--neutral100, #2c2e30);
}
.checkbox-module__checkbox__label--subtitle___AZypU {
  display: unset;
}
.checkbox-module__checkbox__label--reversed___L7uii {
  padding: 0 12px 0 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./node_modules/wa-storybook/components/inputs/checkbox-comp/checkbox.module.scss","webpack://./node_modules/wa-storybook/styles/tools/mixins/_focus-outline.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,WAAA;EACA,aAAA;AAMF;AAJE;EACE,2BAAA;EACA,yBAAA;AAMJ;AAHE;EACE,kBAAA;EACA,2CAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AAKJ;AAHI;EACE,YAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AAKN;AAFI;ECtBA,wCAAA;EACA,mBAAA;AD2BJ;AAFI;EACE,yDAAA;EACA,0BAAA;AAIN;AADI;EACE,yDAAA;EACA,0BAAA;AAGN;AAAI;EACE,yDAAA;EACA,0BAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAEN;AACI;EAKE,4CAAA;AAHN;AAOE;EACE,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,iCAAA;EACA,+BAAA;AALJ;AAOI;EACE,iCAAA;EACA,gBAAA;AALN;ACtDI;EACE,wCAAA;EACA,mBAAA;ADwDN;AAKI;EACE,gBAAA;AAHN;AAMI;EACE,eAAA;EACA,iCAAA;AAJN;AAOI;EACE,YAAA;AALN;AAQI;EAEE,eAAA;EACA,gBAAA;AAPN;AAWE;EACE,qBAAA;EACA,sBAAA;EACA,4BAAA;EACA,mBAAA;EACA,gCAAA;AATJ;AAYE;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;AAVJ;AAYI;EACE,WAAA;AAVN;AAaI;EACE,iBAAA;AAXN;AAcI;EACE,cAAA;AAZN;AAgBM;EACE,iCAAA;AAdR;AAgBQ;EAME,iCAAA;AAnBV;AAwBI;EACE,cAAA;AAtBN;AAyBI;EACE,mBAAA;AAvBN","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '../../../styles/utils';\n\n.checkbox {\n  width: 100%;\n  display: flex;\n\n  &--reversed {\n    flex-direction: row-reverse;\n    justify-content: flex-end;\n  }\n\n  &__checkmark {\n    border-radius: 5px;\n    border: 1px solid color(neutral45);\n    background-image: none;\n    height: 22px;\n    width: 22px;\n    flex-shrink: 0;\n\n    > input {\n      height: 100%;\n      width: 100%;\n      opacity: 0;\n      margin: 0;\n    }\n\n    &:focus-within {\n      @include focus-outline($applyDirectly: true);\n    }\n\n    &--checked {\n      background-image: url('../../../assets/icn-checkbox-checked.svg');\n      background-size: 100% 100%;\n    }\n\n    &--checked-dark {\n      background-image: url('../../../assets/icn-checkbox-checked-dark.svg');\n      background-size: 100% 100%;\n    }\n\n    &--checked-read-only {\n      background-image: url('../../../assets/icn-checkbox-checked-read-only.png');\n      background-size: 100% 100%;\n      border: none;\n      width: 24px;\n      height: 24px;\n    }\n\n    &--sftp-steps,\n    &--invite-modal-comp,\n    &--format,\n    &--preview,\n    &--health-coaching {\n      border: 1px solid color(primary600);\n    }\n  }\n\n  &__title {\n    vertical-align: middle;\n    font-size: rem(14);\n    height: 20px;\n    color: color(neutral100);\n    transition: 0.3s ease-out color;\n\n    a {\n      color: color(primary600);\n      font-weight: 600;\n      @include focus-outline;\n    }\n\n    &--sftp-steps {\n      padding-top: 1px;\n    }\n\n    &--invite-modal-comp {\n      font-size: rem(16);\n      color: color(neutral100);\n    }\n\n    &--consents {\n      height: auto;\n    }\n\n    &--preview,\n    &--appointments-form {\n      font-size: rem(16);\n      font-weight: 600;\n    }\n  }\n\n  &__subtitle {\n    display: inline-block;\n    vertical-align: middle;\n    max-width: calc(100% - 32px);\n    font-size: rem(14);\n    color: color(neutral75);\n  }\n\n  &__label {\n    padding-left: 12px;\n    display: inline-flex;\n    align-items: center;\n\n    &--appointments-form {\n      width: 100%;\n    }\n\n    &--sftp-steps {\n      padding-left: 8px;\n    }\n\n    &--invite-modal-comp {\n      display: block;\n    }\n\n    &--checked {\n      .checkbox__title {\n        color: color(primary600);\n\n        &--consents,\n        &--sftp-steps,\n        &--invite-modal-comp,\n        &--format,\n        &--preview,\n        &--appointments-form {\n          color: color(neutral100);\n        }\n      }\n    }\n\n    &--subtitle {\n      display: unset;\n    }\n\n    &--reversed {\n      padding: 0 12px 0 0;\n    }\n  }\n}\n","@import '../functions/color';\n\n@mixin focus-outline($color: color(focus), $applyDirectly: false) {\n  @if $applyDirectly {\n    outline: $color solid 2px;\n    outline-offset: 3px;\n  } @else {\n    &:focus {\n      outline: $color solid 2px;\n      outline-offset: 3px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox": `checkbox-module__checkbox___WmLHf`,
	"checkbox--reversed": `checkbox-module__checkbox--reversed___LecXB`,
	"checkbox__checkmark": `checkbox-module__checkbox__checkmark___dboH6`,
	"checkbox__checkmark--checked": `checkbox-module__checkbox__checkmark--checked___kU20r`,
	"checkbox__checkmark--checked-dark": `checkbox-module__checkbox__checkmark--checked-dark___PA4vf`,
	"checkbox__checkmark--checked-read-only": `checkbox-module__checkbox__checkmark--checked-read-only___eqsK6`,
	"checkbox__checkmark--sftp-steps": `checkbox-module__checkbox__checkmark--sftp-steps___qKRNI`,
	"checkbox__checkmark--invite-modal-comp": `checkbox-module__checkbox__checkmark--invite-modal-comp___BjjP6`,
	"checkbox__checkmark--format": `checkbox-module__checkbox__checkmark--format___clFr3`,
	"checkbox__checkmark--preview": `checkbox-module__checkbox__checkmark--preview___cHWHW`,
	"checkbox__checkmark--health-coaching": `checkbox-module__checkbox__checkmark--health-coaching___ccn_P`,
	"checkbox__title": `checkbox-module__checkbox__title___CxVRF`,
	"checkbox__title--sftp-steps": `checkbox-module__checkbox__title--sftp-steps___cKLYT`,
	"checkbox__title--invite-modal-comp": `checkbox-module__checkbox__title--invite-modal-comp___P1lTO`,
	"checkbox__title--consents": `checkbox-module__checkbox__title--consents___SbqZk`,
	"checkbox__title--preview": `checkbox-module__checkbox__title--preview___LmN_T`,
	"checkbox__title--appointments-form": `checkbox-module__checkbox__title--appointments-form___mVFlu`,
	"checkbox__subtitle": `checkbox-module__checkbox__subtitle___xjWqz`,
	"checkbox__label": `checkbox-module__checkbox__label___ALUoq`,
	"checkbox__label--appointments-form": `checkbox-module__checkbox__label--appointments-form___q7ryI`,
	"checkbox__label--sftp-steps": `checkbox-module__checkbox__label--sftp-steps___paVws`,
	"checkbox__label--invite-modal-comp": `checkbox-module__checkbox__label--invite-modal-comp___XPGSn`,
	"checkbox__label--checked": `checkbox-module__checkbox__label--checked___s2lyD`,
	"checkbox__title--format": `checkbox-module__checkbox__title--format___c6t25`,
	"checkbox__label--subtitle": `checkbox-module__checkbox__label--subtitle___AZypU`,
	"checkbox__label--reversed": `checkbox-module__checkbox__label--reversed___L7uii`
};
export default ___CSS_LOADER_EXPORT___;
